import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    systemSettings: {}
  },
  mutations: {
    SET_SYSTEM_SETTINGS(state, settings) {
      state.systemSettings = settings
    }
  },
  actions: {
    setSystemSettings({ commit }, settings) {
      commit('SET_SYSTEM_SETTINGS', settings)
    }
  },
  getters: {
    systemSettings: state => state.systemSettings
  }
})

export default store